<div id="page-wrapper" class="ic1-row">
  <div id="page-content" class="ic1-col-12 ic1-col-md-9">
    <ng-content></ng-content>
  </div>

  <div id="page-sidebar" class="ic1-col-12 ic1-col-md-3">
    <ng-content select="[sidebar]"></ng-content>
  </div>
</div>
